import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";

export default class ButtonText extends Phaser.GameObjects.Container {
    constructor(scene, x, y, {text, textColor = Colors.Text.White, textHoverColor}) {
        super(scene, x, y, []);

        this.scene = scene;
        scene.add.existing(this);

        this.soundManager = scene.soundManager

        this.isLocked = false

        this.textColor = textColor
        this.textHoverColor = textHoverColor

        this.addBody({text, textColor})        
        // Ajout intéractions
        this.setInteractive({useHandCursor: true});

        this.on('pointerover', () => {
            this.pointerOver()
        })

        this.on('pointerout', () => {
            this.pointerOut()
        })
    }

    addInconOnLeft(icon, padding, scale = 1, flipX = false){
        this.icon = this.scene.add.image(-this.textElmt.width/2 - padding, 0, icon).setOrigin(1, 0.5);
        this.icon.setScale(scale)
        this.add(this.icon)
        if(flipX)
            this.icon.setFlipX(true)

        // Adjust position & size
        this.icon.x = this.icon.width
        this.textElmt.x = this.icon.x + this.textElmt.width/2 + padding

        this.setSize(this.textElmt.x + this.textElmt.width/2, this.textElmt.height)
        this.removeInteractive()
        this.setInteractive({useHandCursor: true});

        this.textElmt.x -= this.width/2
        this.icon.x -= this.width/2
    }

    addInconOnRight(icon, padding, scale = 1, flipX = false){
        this.icon = this.scene.add.image(0, 0, icon).setOrigin(0, 0.5);
        this.icon.setScale(scale)
        this.add(this.icon)
        if(flipX)
            this.icon.setFlipX(true)

        // Adjust position & size
        this.textElmt.x = this.textElmt.width/2
        this.icon.x = this.textElmt.x + this.textElmt.width/2 + padding

        this.setSize(this.icon.x + this.icon.width, this.textElmt.height)
        this.removeInteractive()
        this.setInteractive({useHandCursor: true});

        this.textElmt.x -= this.width/2
        this.icon.x -= this.width/2
    }

    setClickFunction( clickFunction ){
        this.on('pointerup', () => {
            this.soundManager.playOnce('Button3')
            this.scene.tweens.add({
                targets: this,
                scale: 0.9,
                duration: 100,
                yoyo: true,
                ease: 'Cubic.easeInOut',
                onComplete: () => {
                    clickFunction(this);
                }
            })
        }, this.scene);
    }

    // -- A completer dans les class enfants

    addBody({text, textColor}){
        this.textElmt = this.scene.add.text(0, 0, text, {
            fontFamily: FONTS.InterSemiBold,
            fontSize: '22px',
            color: textColor,
        });
        this.textElmt.setOrigin(0.5);
        this.add(this.textElmt);

        this.setSize(this.textElmt.width, this.textElmt.height);
    }

    pointerOver(){
        if(this.textHoverColor)
            this.scene.tweenTextColor(this.textElmt, this.textHoverColor, 200);
    }

    pointerOut(){
        if(this.textHoverColor)
            this.scene.tweenTextColor(this.textElmt, this.textColor, 200);
    }

    setLocked(){
        // Ajout de l'état bloqué
        this.isLocked = true
    }

    setUnlocked(){
        // Ajout de l'état débloqué
        this.isLocked = false
    }
}